import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../config/apiCaller.config";
import { useAuth } from "./useAuth.hook";

interface WalletContext {
    points: number | undefined;
    loadWallet: () => Promise<void>;
}

const WalletContext = createContext<WalletContext | undefined>(undefined);

export const WalletProvider = ({ children }: {children: any}) => {
    const [points, setPoints] = useState();
    const { token } = useAuth();

    useEffect(() => {
        if (token) {
            loadWallet();
        }
    }, [token]);


    const loadWallet = async () => {
        try {
            const response = await api.get('/wallet');
            setPoints(response.data.points);
        } catch (error: any) {
            setPoints(undefined);
            return error.response;
        }
    }

    const value = useMemo(
        () => ({
            points,
            loadWallet,
        }),
        [points]
    );

    return (
        <WalletContext.Provider value={value}>
            {children}
        </WalletContext.Provider>
    )
}

export const useWallet = () => {
    const context = useContext(WalletContext);

    if (!context) {
        throw new Error('useWallet must be used within a WalletProvider');
    }

    return context;
}

